import { Text } from "@overmap-ai/blocks"
import { UNTITLED_DOCUMENT_TITLE } from "@overmap-ai/common"
import type { Document, Stored } from "@overmap-ai/common"
import { forwardRef, memo } from "react"

import { DocumentIcon } from "../../../components/Icons/DocumentIcon"
import {
	MentionListEmpty,
	MentionListItem,
	type MentionListRef,
	MentionListRoot,
	type MentionListRootProps,
} from "../../blocks"

type DocumentMentionListProps = MentionListRootProps<Stored<Document>>

export const DocumentMentionList = memo(
	forwardRef<MentionListRef<Stored<Document>>, DocumentMentionListProps>((props, ref) => {
		const { items } = props

		return (
			<MentionListRoot<Stored<Document>> ref={ref} {...props}>
				{items.map((document) => (
					<MentionListItem<Stored<Document>> item={document} key={document.uuid}>
						<DocumentIcon documentId={document.uuid} inline />
						<Text className="truncate">{document.title || UNTITLED_DOCUMENT_TITLE}</Text>
					</MentionListItem>
				))}
				<MentionListEmpty>No results</MentionListEmpty>
			</MentionListRoot>
		)
	}),
)
DocumentMentionList.displayName = "DocumentMentionList"
